import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
import notiAlert from "@frameworks/web/assets/images/features/TOC/Common/notification.svg";
const NotificationMessage = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: `notificationbox ${props.parentclass}`, style: {
                    backgroundColor: props.backColor,
                    borderColor: props.borderColor,
                } },
                React.createElement("div", { className: "notit-ls" },
                    props.notiiconAlert ? React.createElement("img", { src: notiAlert }) : null,
                    props.prefredIcon ? (React.createElement("i", { className: "edel-icon-zigzag txt-orange-light " })) : null),
                React.createElement("div", { className: "notit-rs" },
                    React.createElement("h1", { className: "DMSanM_14_500 txt_blackOne1" }, props.notiHeading),
                    React.createElement("p", { className: "DMsanR_10_400 txt_primaryGrey" }, props.DescriptionTop),
                    props.ShowlinkValue ? (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom text-left notificationbtn w-80", value: props.linkValue })) : null,
                    props.showDescriptionBottom ? (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: "DMsanR_10_400 txt_primaryGrey mt-3" }, props.DescriptionBottom))) : null)))));
};
export default NotificationMessage;
